import api from './apiClient';
import { PetReminder, PetReminderCreate, PetReminderUpdate } from '../types';

class ReminderService {
  /**
   * Crear un nuevo recordatorio para una mascota
   */
  async createReminder(petId: number, data: PetReminderCreate): Promise<PetReminder> {
    const response = await api.post<PetReminder>(`/pets/${petId}/reminders`, data);
    return response.data;
  }

  /**
   * Obtener recordatorios de una mascota
   */
  async getPetReminders(
    petId: number,
    status?: 'active' | 'completed' | 'cancelled'
  ): Promise<PetReminder[]> {
    const params = status ? { status } : {};
    const response = await api.get<PetReminder[]>(`/pets/${petId}/reminders`, { params });
    return response.data;
  }

  /**
   * Obtener recordatorios próximos
   */
  async getUpcomingReminders(
    petId?: number,
    daysAhead: number = 30
  ): Promise<PetReminder[]> {
    const params: any = { days_ahead: daysAhead };
    if (petId) {
      params.pet_id = petId;
    }
    const response = await api.get<PetReminder[]>('/reminders/upcoming', { params });
    return response.data;
  }

  /**
   * Obtener un recordatorio por ID
   */
  async getReminder(reminderId: number): Promise<PetReminder> {
    const response = await api.get<PetReminder>(`/reminders/${reminderId}`);
    return response.data;
  }

  /**
   * Actualizar un recordatorio
   */
  async updateReminder(reminderId: number, data: PetReminderUpdate): Promise<PetReminder> {
    const response = await api.put<PetReminder>(`/reminders/${reminderId}`, data);
    return response.data;
  }

  /**
   * Eliminar un recordatorio
   */
  async deleteReminder(reminderId: number): Promise<void> {
    await api.delete(`/reminders/${reminderId}`);
  }
}

export const reminderService = new ReminderService();
